// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3vGOS","questions":"styles_questions__1ZGkG","footer":"styles_footer__hTwje"};